const data = () => {
  return {
    loading: false,
    dropdownVisible: false
  };
};

export default data;
